import { render, staticRenderFns } from "./HomeNext.vue?vue&type=template&id=2346850b&scoped=true&"
import script from "./HomeNext.vue?vue&type=script&lang=js&"
export * from "./HomeNext.vue?vue&type=script&lang=js&"
import style0 from "./HomeNext.vue?vue&type=style&index=0&id=2346850b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2346850b",
  null
  
)

export default component.exports